export default {
    list: {
        title: 'Zóny',
        empty: 'Žádné zóny',
        search: 'Hledat zóny…'
    },
    fields: {
        name: 'Název',
        validSince: 'Platné od (min)',
        validUntil: 'Platné do (min)',
        slots: 'Sloty',
        noSlots: 'Žádné sloty'
    },
    qr: {
        title: 'Konfigurační QR pro zónu',
        addToClipboard: 'Přidat do schránky',
        added: 'Přidáno do schránky'
    }
}
